import { useQuery } from "@tanstack/react-query";
import { legacyReportsService } from "../services/legacyReports.service";

export function useLegacyReportReview(caseId: string | undefined) {
  return useQuery({
    queryKey: ["legacy-report-review", caseId],
    queryFn: () => legacyReportsService.get(caseId!),
    enabled: Boolean(caseId),
    refetchOnWindowFocus: false,
  });
}
